import { Button, Stack } from "@mui/material";
import CreationSelectionModal from "../Signups/CreationSelectionModal";
import GameRegistrationModal from "../CreateEventModal/GameRegistrationModal";
import { Dispatch, useEffect, useState } from "react";
import { SetStateAction } from "react";
import { useNavigate } from "react-router-dom";
import RegisterLessonModal from "../CreateEventModal/RegisterLessonModal";
import getProMapping from "../Signups/getProMapping";
import RegisterTournamentModal from "../CreateEventModal/RegisterTournament";
import Grid from "@mui/material/Grid2";

export interface proMappingInterface {
  [key: number]: string;
}
function EventCreationBanner({
  createModal,
  setCreateModal,
  setRegisterModal,
  devPort,
  clubId,
  setAlertMessage,
  setMessageContent,
  filterGames,
  setGameToDelete,
  setDeleteModal,
  updateModal,
  setUpdateModal,
  registerModal,
  setPricingTab,
  eventToEdit,
  setEventToEdit,
  betaMode,
  displayTournamentModal,
  setDisplayTournamentModal,
  updateLessonModal,
  setUpdateLessonModal,
  setLessonToDeleteId,
  setLessonDeleteMessage,
}: {
  createModal: boolean;
  setCreateModal: Dispatch<SetStateAction<boolean>>;
  setRegisterModal: Dispatch<SetStateAction<boolean>>;
  devPort: string;
  clubId: number;
  setAlertMessage: (message: string) => void;
  setMessageContent: (content: string) => void;
  filterGames: () => void;
  setGameToDelete: (gameId: number) => void;
  setDeleteModal: (modal: boolean) => void;
  updateModal: boolean;
  setUpdateModal: (modal: boolean) => void;
  registerModal: boolean;
  setPricingTab: (tab: string) => void;
  eventToEdit: any;
  setEventToEdit: any;
  betaMode: boolean;
  displayTournamentModal: boolean;
  setDisplayTournamentModal: Dispatch<SetStateAction<boolean>>;
  updateLessonModal: boolean;
  setUpdateLessonModal: Dispatch<SetStateAction<boolean>>;
  setLessonToDeleteId: (id: any) => void;
  setLessonDeleteMessage: (message: string) => void;
}) {
  const navigate = useNavigate();
  const [displayLessonModal, setDisplayLessonModal] = useState(false);

  const [proMapping, setProMapping] = useState<proMappingInterface>({});
  //const [loadingClubPros, setLoadingClubPros] = useState(true);
  useEffect(() => {
    const player_fetcher = devPort + "player_list/" + clubId + "/True";
    getProMapping(
      devPort,
      player_fetcher,
      setProMapping,
      () => {},
      () => {} //setLoadingClubPros
    );
  }, [devPort, clubId]);
  return (
    <Stack>
      <CreationSelectionModal
        createModal={createModal}
        setCreateModal={setCreateModal}
        setRegisterModal={setRegisterModal}
        setDisplayLessonModal={setDisplayLessonModal}
        setDisplayTournamentModal={setDisplayTournamentModal}
        betaMode={betaMode}
      />
      <GameRegistrationModal
        devPort={devPort}
        registerModal={registerModal}
        setRegisterModal={setRegisterModal}
        clubId={clubId}
        setAlertMessage={setAlertMessage}
        setMessageContent={setMessageContent}
        filterGames={filterGames}
        modalType="save"
        setGameToDelete={setGameToDelete}
        setDeleteModal={setDeleteModal}
        gameToEdit={null}
        setGameToEdit={null}
      />
      <GameRegistrationModal
        devPort={devPort}
        registerModal={updateModal}
        setRegisterModal={setUpdateModal}
        clubId={clubId}
        setAlertMessage={setAlertMessage}
        setMessageContent={setMessageContent}
        filterGames={filterGames}
        modalType="update"
        setGameToDelete={setGameToDelete}
        setDeleteModal={setDeleteModal}
        gameToEdit={eventToEdit}
        setGameToEdit={setEventToEdit}
      />
      <RegisterLessonModal
        devPort={devPort}
        clubId={clubId}
        proMapping={proMapping}
        registerModal={displayLessonModal}
        setRegisterModal={setDisplayLessonModal}
        onRefresh={filterGames}
      />
      <RegisterLessonModal
        devPort={devPort}
        clubId={clubId}
        proMapping={proMapping}
        registerModal={updateLessonModal}
        setRegisterModal={setUpdateLessonModal}
        onRefresh={filterGames}
        modalType="update"
        lessonToEdit={eventToEdit}
        setLessonToEdit={setEventToEdit}
        setLessonToDeleteId={setLessonToDeleteId}
        setLessonDeleteMessage={setLessonDeleteMessage}
      />
      <RegisterTournamentModal
        devPort={devPort}
        clubId={clubId}
        registerModal={displayTournamentModal}
        setRegisterModal={setDisplayTournamentModal}
        eventToEdit={eventToEdit}
        filterGames={filterGames}
        setEventToEdit={setEventToEdit}
      />
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }}>
          <Button
            variant="contained"
            color="success"
            fullWidth
            size="large"
            onClick={() => {
              //setRegisterModal(true);
              setCreateModal(true);
            }}
          >
            Create New Event
          </Button>
        </Grid>
        <Grid size={{ xs: 6 }}>
          <Button
            fullWidth
            onClick={() => {
              setPricingTab("Membership");
              navigate("/lessonmanagepricing");
            }}
            variant="outlined"
            size="large"
            color="primary"
          >
            Set Pricing
          </Button>
        </Grid>
      </Grid>
    </Stack>
  );
}

export default EventCreationBanner;
